//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatConfiguredTime } from '../../../../components/helpers.js'

import ReportCheckListCombobox from './ReportCheckListCombobox.vue'
import ReportCheckListText from './ReportCheckListText.vue'
import ReportCheckListLocation from './ReportCheckListLocation.vue'
import ReportCheckListNumber from './ReportCheckListNumber.vue'
import ReportCheckListAuditDt from './ReportCheckListAuditDt.vue'
import ReportCheckListCable from './ReportCheckListCable/ReportCheckListCable.vue'
import ReportCheckListRadioButtons from './ReportCheckListRadioButtons.vue'
import ReportCheckListFile from './ReportCheckListFile.vue'
import ReportCheckListBeaconQRPhoto from './ReportCheckListBeaconQRPhoto.vue'
import ReportCheckListBeaconSerialNumber from './ReportCheckListBeaconSerialNumber.vue'
import ReportCheckListConstruction from './ReportCheckListConstruction.vue'
import ReportCheckListCamMetro from './ReportCheckListCamMetro.vue'
import ReportCheckListSoStands from './ReportCheckListSoStands.vue'
import ReportCheckListRemontJ from './ReportCheckListRemontJ.vue'
import ReportCheckListOutlay from './ReportCheckListOutlay/ReportCheckListOutlay.vue'
import ReportCheckListSoDirTable from './ReportCheckListSoDirTable.vue'
import ReportCheckListServiceObject from './ReportCheckListServiceObject.vue'
import ReportCheckListRef from './ReportCheckListRef.vue'
import ReportCheckListHistoryRecords from '../ReportCheckListHistoryRecords.vue'

export default {
  name: 'ReportCheckListWorkResultsTypes',
  components: {
    ReportCheckListCombobox,
    ReportCheckListText,
    ReportCheckListLocation,
    ReportCheckListNumber,
    ReportCheckListRadioButtons,
    ReportCheckListFile,
    ReportCheckListBeaconQRPhoto,
    ReportCheckListBeaconSerialNumber,
    ReportCheckListAuditDt,
    ReportCheckListCable,
    ReportCheckListConstruction,
    ReportCheckListCamMetro,
    ReportCheckListRemontJ,
    ReportCheckListOutlay,
    ReportCheckListSoDirTable,
    ReportCheckListSoStands,
    ReportCheckListServiceObject,
    ReportCheckListRef,
    ReportCheckListHistoryRecords
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    workType: {
      type: Object,
      required: true
    },
    technologicalOperation: {
      type: Object,
      required: true
    },
    workResultsType: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    showPreviousDepartures: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    readonly () {
      return !this.workType.includedInCurrentReport || !this.reportActionsAccess.editData
    }
  },
  methods: {
    formatConfiguredTime: function (val) {
      return formatConfiguredTime(val, { year: true, month: true, date: true, hour: true, min: true, sec: false })
    }
  }
}

